// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__r4EQC","dot":"index_dot__Dg65X","dotter":"index_dotter__txhfI","glow":"index_glow__+VWLa"};